/**
 * Reference Data Store
 * Jotai atoms for employees, projects, customers, and activities
 * Uses jotai-tanstack-query for server state management with caching
 */

import { atomWithQuery } from "jotai-tanstack-query";
import { servicesAPI } from "@/services";
import type {
  IServiceEmployee,
  IServiceProject,
  IServiceCustomer,
  IServiceActivity,
} from "@/services";

/**
 * Employees query atom
 * - Fetches all employees from API
 * - 5 minute stale time (rarely changes)
 */
export const employeesQueryAtom = atomWithQuery(() => ({
  queryKey: ["employees"],
  queryFn: () => servicesAPI.getEmployees(),
  staleTime: 5 * 60 * 1000, // 5 minutes
}));

/**
 * Projects query atom
 * - Fetches all projects with timesheetentry=1
 * - 5 minute stale time
 */
export const projectsQueryAtom = atomWithQuery(() => ({
  queryKey: ["projects"],
  queryFn: () => servicesAPI.getProjects(),
  staleTime: 5 * 60 * 1000, // 5 minutes
}));

/**
 * Customers query atom
 * - Fetches all customers
 * - 5 minute stale time
 */
export const customersQueryAtom = atomWithQuery(() => ({
  queryKey: ["customers"],
  queryFn: () => servicesAPI.getCustomers(),
  staleTime: 5 * 60 * 1000, // 5 minutes
}));

/**
 * Activities query atom
 * - Fetches all activities (filtered to those with codes)
 * - 10 minute stale time (very stable data)
 */
export const activitiesQueryAtom = atomWithQuery(() => ({
  queryKey: ["activities"],
  queryFn: () => servicesAPI.getActivities(),
  staleTime: 10 * 60 * 1000, // 10 minutes
}));

// Re-export types for convenience
export type {
  IServiceEmployee,
  IServiceProject,
  IServiceCustomer,
  IServiceActivity,
};
